import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudExRelacionAtestacionesViewModel } from './relacionatestaciones.types';
import { RelacionAtestacionesService } from './relacionatestaciones.service';
import { TClaveSolicitudAtestFitoViewModel } from '../../atestaciones/datosbasicos/datosbasicosAtestFito.types';
import { EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-relacionatestaciones',
    templateUrl: './relacionatestaciones.component.html',
})
export class RelacionatestacionesComponent extends ComponentBase implements OnInit {
    relacionAtestaciones: SolicitudExRelacionAtestacionesViewModel;
    //habilitarGuardar: boolean = true;
    //habilitarEdicion: boolean = true;
    visibilitySpinner = false;
    tituloTipoSolicitud: string;
    //laHeGrabadoYo: boolean = false;
    esClonada = false;
    numeroAtestaciones = 0;
    claveSolicitudAtestFitoCollection: TClaveSolicitudAtestFitoViewModel[];
    idSolicitudEx: number;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    colsAtestacion: any[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private relacionatestacionesService: RelacionAtestacionesService,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.relacionAtestaciones = new SolicitudExRelacionAtestacionesViewModel();
    }

    ngOnInit() {
        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        //this.createForm();

        //Siempre tendrá un id
        if (this.idSolicitudEx) {
            this.loading = true;

            this.claveSolicitudAtestFitoCollection = [];

            //Para saber si se actua como Inspector o Grabador
            //let params = new HttpParams();
            //params = params.append('idSolicitudEx', id.toString());
            //params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            //this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {

            //    this.laHeGrabadoYo = resultIsGrabada;

            //recuperar la solicitud
            this.relacionatestacionesService.getRelacionatestaciones(this.idSolicitudEx).subscribe(result => {
                this.relacionAtestaciones = result;

                this.tituloTipoSolicitud = this.relacionAtestaciones.IdTipoSolicitudExDescripcion;
                this.esClonada =
                    this.relacionAtestaciones.TwSolicitudJerarquiaEx != null &&
                    this.relacionAtestaciones.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES PREVIA
                //if (this.relacionAtestaciones.EsPrevia) {
                //    if (this.relacionAtestaciones.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                //        this.relacionAtestaciones.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE) {
                //        this.tituloTipoSolicitud += "-Previa";
                //    }
                //}

                //this.updateForm();
                //for (var i = 0; i < this.atestFitoCollection.length; i++) {
                //    solicitudEx.ListSolicitudesAtestacionFito.push(this.atestFitoCollection[i].IdSolicitudAtestFito)
                //}

                for (let i = 0; i < this.relacionAtestaciones.TSolicitudAtestFitoSolicitudExCollection.length; i++) {
                    //this.claveSolicitudAtestFitoCollection.push(this.relacionAtestaciones.TSolicitudAtestFitoSolicitudExCollection[i].TSolicitudAtestFito.TClaveSolicitudAtestFito)
                    //this.atestFitoCollection = [...this.atestFitoCollection, claveSolicitudAtest];

                    this.claveSolicitudAtestFitoCollection = [
                        ...this.claveSolicitudAtestFitoCollection,
                        this.relacionAtestaciones.TSolicitudAtestFitoSolicitudExCollection[i].TSolicitudAtestFito.TClaveSolicitudAtestFito,
                    ];
                }

                this.numeroAtestaciones = this.claveSolicitudAtestFitoCollection.length;

                this.loading = false;

                //Si soy Inspector-Grabador
                //if (this.isGrabador && this.isInspector) {
                //    this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION, this.solicitudTasasEx.IdEstadoSolicitudEx).Visible && this.laHeGrabadoYo;
                //    this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_TASAS_EXPORTACION, this.solicitudTasasEx.IdEstadoSolicitudEx).Editable && this.laHeGrabadoYo;
                //}
                //else {
                //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION, this.solicitudTasasEx.IdEstadoSolicitudEx).Visible;
                //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_TASAS_EXPORTACION, this.solicitudTasasEx.IdEstadoSolicitudEx).Editable;
                //}

                //if (!this.habilitarEdicion) {
                //    //metodo para deshabilitar los controles
                //    this.DisableControlsConsulta();
                //}
            });

            //})
        }

        this.colsAtestacion = [
            { field: 'Link', header: '' },
            { field: 'IdSolicitudAtestFito', header: '', display: 'none' },
            { field: 'RefAtestFito', header: 'Referencia Atestación' },
        ];
    }

    //private DisableControlsConsulta() {
    //    this.form.controls['TotalTasas'].disable();
    //    this.form.controls['FechaLiquidacion'].disable();
    //    this.form.controls['NumeroLiquidacion'].disable();
    //}

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    //createForm() {
    //    this.form = this.fb.group({
    //        TotalTasas: '',
    //        FechaLiquidacion: '',
    //        NumeroLiquidacion: '',
    //    });
    //}

    //updateForm() {
    //    this.form.setValue({
    //        TotalTasas: '',
    //        FechaLiquidacion: '',
    //        NumeroLiquidacion: '',
    //    })
    //}

    onShowAtestacion(item: TClaveSolicitudAtestFitoViewModel) {
        this.router.navigate(['/exportacion/atestacion/datosbasicos', item.IdSolicitudAtestFito]);

        //se abre en modo nueva pestaña
        //const url = this.router.serializeUrl(this.router.createUrlTree(['/exportacion/atestacion/datosbasicos/' + item.IdSolicitudAtestFito]));
        //var win = window.open(url, '_blank');
        //win?.focus();

        //se abre en modo nueva pestaña
        //let url = "/exportacion/atestacion/datosbasicos/" + item.IdSolicitudAtestFito;
        //var win = window.open(url, '_blank');
        //win?.focus();
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.relacionAtestaciones.Id]);
    }
}
